"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.storageAvailable = storageAvailable;
exports.isMobile = isMobile;
exports.hasDuplicates = hasDuplicates;
exports.filesize = filesize;
String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, "g"), replacement);
};

var uuid = require("uuid");

var moment = window.moment = require("moment");

window.Fn = {
  toggleMenu: function toggleMenu(name) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    Event.fire("toggle-" + name + "-menu", params);
  },
  userHasPermission: function userHasPermission(permissionName) {
    if (this.isAdmin()) {
      return true;
    }

    return window.globals.user.permissions.common.findIndex(function (permission) {
      return permission.name === permissionName;
    }) !== -1;
  },
  userCan: function userCan(permissionName, unitType, unitId) {
    if (this.isAdmin()) {
      return true;
    }

    return _.get(window.globals.user.permissions.model_related, [unitType, unitId], []).findIndex(function (permission) {
      return permission.name === permissionName;
    }) !== -1;
  },
  isAdmin: function isAdmin() {
    if (window.globals.user === undefined) {
      return false;
    }

    return window.globals.user.roles.indexOf("admin") !== -1;
  },
  isTestLeader: function isTestLeader() {
    if (window.globals.user === undefined) {
      return false;
    }

    return window.globals.user.roles.indexOf("test_manager") !== -1;
  },
  isCurrentUser: function isCurrentUser(id) {
    if (window.globals.user === undefined) {
      return false;
    }

    return id === window.globals.user.id;
  },
  hasResponsibilities: function hasResponsibilities(unit) {
    var value = this.getNested(window, "globals.user.responsibilities.projects");

    return this.isAdmin() || this.isTestLeader() || _(value).some({ id: unit.id });
  },
  whereUserCan: function whereUserCan(task, unitType, units) {
    var _this = this;

    return _(units).filter(function (unit) {
      return _this.userCan(task, unitType, unit.id);
    }).value();
  },
  toPath: function toPath(namePrefix) {
    return namePrefix.replaceAll("]", "").split("[").join(".");
  },
  isPast: function isPast(compare) {
    return _(compare).filter(function (item) {
      return moment().isAfter(moment(item.end_date));
    }).value().length;
  },
  isBetween: function isBetween(compare) {
    return _(compare).filter(function (item) {
      return moment().isBetween(moment(item.start_date), moment(item.end_date));
    }).value().length;
  },
  slugify: function slugify(value) {
    return value.toLowerCase().replaceAll(" ", "-");
  },
  random: function random(prefix) {
    return prefix + uuid.v4().replaceAll("-", "");
  },
  isNumeric: function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  },
  getNested: function getNested(object, string) {
    try {
      return _typeof(eval(object + "." + string));
    } catch (e) {
      return null;
    }
  },
  isEmpty: function isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;
    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== "object") return true;

    return true;
  },
  getAge: function getAge(dateOfBirth) {
    var today = moment();
    var birthDate = moment(dateOfBirth);
    var age = today.year() - birthDate.year();
    var m = today.month() - birthDate.month();

    if (m < 0 || m === 0 && today.date() < birthDate.date()) {
      age--;
    }

    return age;
  },
  addZeroBefore: function addZeroBefore(number) {
    var intNumber = parseInt(number);

    return (intNumber < 10 ? "0" : "") + intNumber;
  },
  getFormattedDate: function getFormattedDate(dateString) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Y-MM-DD HH:mm";

    var momentObject = moment(dateString);

    if (!momentObject.isValid()) {
      return "";
    }

    return momentObject.format(format);
  },
  isObject: function isObject(variable) {
    return (typeof variable === "undefined" ? "undefined" : _typeof(variable)) === "object" && variable !== null;
  }
};

function storageAvailable(type) {
  var storage = void 0;
  try {
    storage = window[type];
    var x = "__storage_test__";
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return e instanceof DOMException && (
    // everything except Firefox
    e.code === 22 ||
    // Firefox
    e.code === 1014 ||
    // test name field too, because code might not be present
    // everything except Firefox
    e.name === "QuotaExceededError" ||
    // Firefox
    e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
    // acknowledge QuotaExceededError only if there's something already stored
    storage && storage.length !== 0;
  }
}

function isMobile() {
  var useragent = navigator.userAgent || navigator.vendor || window.opera;

  var mobileRegexp = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;
  var substrRegexp = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;

  return useragent && (mobileRegexp.test(useragent) || substrRegexp.test(useragent.substr(0, 4)));
}

function hasDuplicates(arr) {
  return new Set(arr).size !== arr.length;
}

function filesize(bytes) {
  return {
    mb: function mb() {
      return bytes / Math.pow(1024, 2);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/utilities/functions.js
// module id = Hc8o
// module chunks = 0 1